import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { CovenantReviewGrid } from '$/components/covenant-review-grid';
import { getCreditSightsCovenantReviewFeatureFlagState } from '$/store/release-feature-flags/selectors';
import NotFound from '$/pages/not-found';
import { toastError } from '$/store/toast/actions';
import * as Bixby from '$/core';

interface ICompanyCovenantReviewProps {
  featureFlags?: string[];
  isCreditSightsCovenantReviewEnabled: boolean;
  currentCompany?: Bixby.Models.Company;
  dispatchToastError: (message: string) => void;
}

const CompanyCovenantReview: React.FC<ICompanyCovenantReviewProps> = props => {
  const {
    featureFlags: featureFlags = [],
    isCreditSightsCovenantReviewEnabled,
    currentCompany,
    dispatchToastError,
  } = props;

  if (
    featureFlags.includes(Bixby.Constants.CLIENT_CREDITSIGHTS_COVENANT_REVIEW) &&
    isCreditSightsCovenantReviewEnabled &&
    currentCompany &&
    currentCompany.declarationType === Bixby.Enums.DeclarationType.Public
  ) {
    return <CovenantReviewGrid companyId={currentCompany.id} dispatchToastError={dispatchToastError} />;
  }

  return <NotFound />;
};

const mapStateToProps = (state: AppState) => {
  const { isCreditSightsCovenantReviewEnabled } = getCreditSightsCovenantReviewFeatureFlagState(state);

  return {
    featureFlags: state.loginState.featureFlags,
    isCreditSightsCovenantReviewEnabled,
    currentCompany: state.portfolioState.currentCompany,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    dispatchToastError: (message: string) => dispatch(toastError(message)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCovenantReview);
